/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {enums} from './enums';
import {diplomatObjectSchema} from './diplomat-object';
import {DiplomatObjectType} from './DiplomatObjectType';
import {passphrase} from 'common/yup/customs/passphrase';

export const ProxyServer = diplomatObjectSchema.shape({
   objectType: diplomatObjectSchema.fields.objectType.default(DiplomatObjectType.enum.PROXY_SERVER),
   description: yup.string(),
   proxyType: yup.string().oneOf(enums.proxyType.keys).default(enums.proxyType.enum.HTTP),
   address: yup.string(),
   port: yup.number().integer(),
   username: yup.string(),
   password: passphrase(),
   defaultProxy: yup.boolean().default(false),
});
export type IProxyServer = yup.InferType<typeof ProxyServer>;
